import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import HotComics from './components/HotComics';
import LatestComics from './components/LatestComics';
import CategoryGrid from './components/CategoryGrid';
import SEOContent from './components/SEOContent';
import { getHotComics, getLatestComics } from '@/mocks/comics';

const SITE_URL = 'https://www.krcomic.com';

export default function Home() {
  const hotComics = getHotComics(6);
  const latestComics = getLatestComics(6);

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫大全',
    url: SITE_URL,
    description: '最新最全的正版韩国漫画在线阅读平台，涵盖热血动作、奇幻冒险、浪漫恋爱、悬疑惊悚等各类题材',
  };

  const webSiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫大全',
    url: SITE_URL,
    description: '免费阅读最新正版韩国漫画，高清画质，每日更新',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩国漫画和日本漫画有什么区别？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩国漫画（Webtoon）通常采用纵向滚动阅读方式，专为移动端优化，内容更新频率高，题材更加多元化。日本漫画则以翻页式阅读为主，画面风格和叙事节奏各有特色。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫大全的漫画资源是否正版？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，韩漫大全所有漫画内容均来自正版授权渠道，确保每位读者都能享受到高清画质的正版漫画阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '如何免费阅读韩国漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以直接在韩漫大全网站上免费浏览所有漫画。无需注册登录，点击即可阅读。',
        },
      },
      {
        '@type': 'Question',
        name: '网站多久更新一次漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫大全坚持每日更新，确保读者能第一时间看到最新的韩国漫画章节。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="韩国漫画-免费韩漫大全-最新正版漫画在线阅读"
        description="韩国漫画、免费韩漫、正版漫画在线阅读平台。在这里您可以免费阅读最新最全的正版韩国漫画，涵盖热血动作、奇幻冒险、浪漫恋爱、悬疑惊悚等各种题材，所有内容均提供高清画质，为您带来流畅而舒适的在线阅读体验，每日更新资源。"
        keywords="韩国漫画,免费韩漫,正版漫画,在线阅读,韩漫大全,热血动作,奇幻冒险,浪漫恋爱,悬疑惊悚"
        canonicalUrl={SITE_URL}
        schema={{ ...organizationSchema, ...webSiteSchema, ...faqSchema }}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <HotComics comics={hotComics} />
        <CategoryGrid />
        <LatestComics comics={latestComics} />
        <SEOContent />
      </main>
      <Footer />
    </>
  );
}